import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import unescapedText from 'I18n/utils/unescapedText';
import { COMPANY_TYPE_ID, CONTACT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { OWNER, PERSONA, PIPELINE_STAGE, SYNC_ACCOUNT } from '../../constants/ReferenceTypes';

// This file is only used with `createExternalOptionsReferenceResolver` and is
// therefore tested with that file to ensure it's wired up correctly.
const getLabel = (referenceType, objectTypeId, reference) => {
  if (referenceType === PIPELINE_STAGE && ![CONTACT_TYPE_ID, COMPANY_TYPE_ID].includes(objectTypeId)) {
    const {
      additionalFields,
      label
    } = reference;
    const pipelineName = additionalFields.label;
    return pipelineName ? `${label} (${pipelineName})` : label;
  }

  if (referenceType === OWNER) {
    const {
      additionalFields,
      label
    } = reference;
    const {
      activeUserId,
      activeSalesforceOwnerId
    } = additionalFields;

    if (activeSalesforceOwnerId !== undefined && activeUserId === undefined) {
      return `${label} ${unescapedText('referenceResolversLite.owners.salesforceOwner')}`;
    } else if (activeUserId === undefined) {
      return `${label} ${unescapedText('referenceResolversLite.owners.deactivatedOwner')}`;
    }

    return label;
  }

  if (referenceType === 'CONVERSATION_INBOX') {
    const {
      archived,
      label
    } = reference;
    return archived ? `${label} ${unescapedText('referenceResolversLite.conversationInbox.archived')}` : label;
  }

  return reference.label;
};

const getIcon = (referenceType, __objectTypeId, reference) => {
  if (referenceType === PERSONA || referenceType === SYNC_ACCOUNT) {
    const {
      additionalFields
    } = reference;
    const iconSrc = additionalFields.iconSrc;
    return iconSrc ? {
      src: iconSrc
    } : undefined;
  }

  return undefined;
};

const formatExternalOptionsReference = (externalOptionReference, options) => {
  const {
    additionalFields,
    description
  } = externalOptionReference,
        rest = _objectWithoutPropertiesLoose(externalOptionReference, ["additionalFields", "description"]);

  const {
    objectTypeId,
    referenceType
  } = options;
  const label = getLabel(referenceType, objectTypeId, externalOptionReference);
  const icon = getIcon(referenceType, objectTypeId, externalOptionReference);
  return Object.assign({}, rest, {
    label,
    additionalProperties: additionalFields
  }, description != null && {
    description
  }, {}, icon != null && {
    icon
  });
};

export const formatExternalOptionsByIdResponse = (externalOptionReferences, options) => {
  return externalOptionReferences.map(reference => formatExternalOptionsReference(reference, options));
};
export const formatExternalOptionsSearchResponse = (apiResult, options) => ({
  hasMore: apiResult.hasMore,
  offset: apiResult.offset,
  references: apiResult.results.map(reference => formatExternalOptionsReference(reference, options))
});